var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoneycomb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332.94604384631816,
    height: 80,
    viewBox: "9.473 9.51 58.515 59.054",
    className: "css-1j8o68f",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1007",
    featurekey: "nRdZyp-0",
    transform: "matrix(0.591989, 0, 0, 0.591989, 9.704814, 9.882456)",
    fill: "#284e31",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "89.1,64.3 82,76.7 67.7,76.7 60.6,64.3 67.7,52 82,52  ",
    style: {
      strokeWidth: "1.0275px",
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.1,35.7 82,48 67.7,48 60.6,35.7 67.7,23.3 82,23.3  ",
    style: {
      strokeWidth: "1.0275px",
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.3,21.3 57.1,33.7 42.9,33.7 35.7,21.3 35.7,21.3 42.9,8.9 57.1,8.9  ",
    style: {
      strokeWidth: "1.0275px",
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.3,50 57.1,62.4 42.9,62.4 35.7,50 42.9,37.6 57.1,37.6  ",
    style: {
      strokeWidth: "1.0275px",
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.4,35.7 32.3,48 18,48 10.9,35.7 18,23.3 32.3,23.3  ",
    style: {
      strokeWidth: "1.0275px",
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.4,64.3 32.3,76.7 18,76.7 10.9,64.3 18,52 32.3,52  ",
    style: {
      strokeWidth: "1.0275px",
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.3,78.7 57.1,91.1 42.9,91.1 35.7,78.7 42.9,66.3 57.1,66.3  ",
    style: {
      strokeWidth: "1.0275px",
      fill: "rgb(255, 255, 255)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoneycomb);
export default __webpack_public_path__ + "static/media/honeycomb.b929ab5f30fe5760a049a1539f274f26.svg";
export { ForwardRef as ReactComponent };